import { jsx as _jsx } from "jsx-dom/jsx-runtime";
/** @jsxImportSource jsx-dom */
import { select } from "@fruugo/utilities";
import { Icon } from "./components/Icon";
var state = {
    open: false,
    initialText: "",
};
export function initShowMoreContent() {
    var _a, _b;
    var button = select(".js-show-more-content");
    if (!button)
        return;
    state.initialText = (_b = (_a = button.querySelector("span")) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : "";
    button.addEventListener("click", function (e) { return e.currentTarget && toggle(e.currentTarget); });
}
function toggle(target) {
    var _a, _b;
    var button = target;
    var text = button === null || button === void 0 ? void 0 : button.querySelector("span");
    var icon = button === null || button === void 0 ? void 0 : button.querySelector(".icon");
    var container = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(".hide-extra-content");
    icon === null || icon === void 0 ? void 0 : icon.remove();
    if (state.open) {
        container === null || container === void 0 ? void 0 : container.classList.remove("expanded");
        if (text)
            text.textContent = state.initialText;
        button.appendChild(_jsx(Icon, { name: "chevron-down" }));
    }
    else {
        container === null || container === void 0 ? void 0 : container.classList.add("expanded");
        if (text)
            text.textContent = (_b = button.dataset.toggleText) !== null && _b !== void 0 ? _b : state.initialText;
        button.appendChild(_jsx(Icon, { name: "chevron-up" }));
    }
    state.open = !state.open;
}
